import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import { PLANS } from '../../config/plans';

const SubscriptionGate = ({
  requiredTier = 'pro',
  featureName = 'cette fonctionnalite',
  children = null,
  onUpgrade = null,
  onClose = null
}) => {
  const features = [
    'Analyse par IA de vos immeubles',
    'Outil de planification d\'investissement 25 ans',
    'Projections fiscales avancees (QC)',
    'Simulation de scenarios de deces',
    'Tresorerie par entite et cashflow',
    'Export PDF professionnel',
    'Support prioritaire',
  ];

  const handleUpgradeClick = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      window.location.href = '/subscription-pricing';
    }
  };

  const handleCloseClick = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-background rounded-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-xl border border-border animate-in fade-in zoom-in duration-200">
        <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Icon name="Crown" size={32} className="text-primary" />
        </div>

        <h2 className="text-2xl font-bold text-foreground text-center mb-2">
          Passez a Pro
        </h2>

        <p className="text-muted-foreground text-center mb-2">
          Debloquez {featureName} et toutes les fonctionnalites avancees.
        </p>

        <p className="text-center mb-6">
          <span className="text-3xl font-bold text-foreground">{PLANS.pro.priceLabel}</span>
        </p>

        <ul className="space-y-3 mb-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <div className="mt-1 min-w-[20px]">
                <Icon name="Check" size={20} className="text-primary" />
              </div>
              <span className="text-sm text-foreground">{feature}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-3">
          <Button
            variant="default"
            size="lg"
            iconName="Crown"
            iconPosition="left"
            onClick={handleUpgradeClick}
            fullWidth
          >
            Voir le plan Pro
          </Button>
          {onClose && (
            <Button
              variant="ghost"
              size="lg"
              onClick={handleCloseClick}
              fullWidth
            >
              Plus tard
            </Button>
          )}
        </div>

        {children && (
          <div className="mt-4">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionGate;
